import styled from 'styled-components';
import DefaultModal from 'components/Modals/Modal';
import { H2 } from 'components/Typography';

export const Modal = styled(DefaultModal)`
  .modal-ui {
    width: 50rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1rem 2rem 1.5rem;
    max-height: 100%;
    overflow-x: hidden;
  }
`;

// TODO: TFR-49 look similar to other content in modals. Could be easier to make helper for modals
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding: 0rem;
  width: 47%;
  min-height: 9.625rem;
  margin-top: 1rem;
`;

export const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  min-height: 17.625rem;
  background: ${({ theme }) => theme.colors.greenMedium};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  padding: 2rem 5rem 1.8rem;
  margin: 2% 0 4%;
`;

export const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 0.5fr;
  justify-content: space-between;
  width: 100%;

  *:nth-child(2n) {
    text-align: right;
  }
`;

export const DetailsBlockTitle = styled(H2)`
  margin-bottom: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray5};
`;

export const BlockTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const BlockTitle = styled(H2)`
  margin-bottom: 0;
`;

export const TitleLine = styled.div`
  width: 10%;
  border-bottom: 1px solid;
  border-color: inherit;
  margin-top: 2%;
`;

export const TitleWithUnderline = styled.p`
  margin-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greenMedium};
  font-size: 1.4rem;
`;

export const SubTitleWithUnderline = styled.p`
  margin-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greenMedium};
  font-size: 1.2rem;
`;

export const TitleWithUnderlineWhite = styled.p`
  margin-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.white};
  font-size: 1.4rem;
`;

export const SubTitleWithUnderlineWhite = styled.p`
  margin-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.white};
  font-size: 1.2rem;
`;

export const CommentText = styled.p`
  font-size: 1rem;
  width: 100%;
  text-align: right;
  margin: 4% 0 2%;
`;

export const ReportText = styled.p`
  font-size: 1rem;
  width: 100%;
  text-align: left;
  margin: 0.5rem 0 2rem;
`;

export const Wrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export const DetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border: 4px solid ${({ theme }) => theme.colors.greenMedium};
  border-radius: 1.5rem;
  padding: 1.5rem;
`;

export const NarrowContainer = styled.div`
  width: 95%;
`;

export const Logo = styled.img`
  width: 90%;
  max-height: 4rem;
  object-fit: cover;
  margin: 0 0 1rem;
`;
